import { NgClass } from '@angular/common';
import { Component, Input } from '@angular/core';

import { FaIconComponent } from '@fortawesome/angular-fontawesome';

import { UrlListItem } from './models';

@Component({
  selector: 'bn-web-ui-url-list',
  templateUrl: './url-list.component.html',
  styleUrls: ['url-list.component.scss'],
  imports: [NgClass, FaIconComponent],
})
export class UrlListComponent {
  // eslint-disable-next-line @angular-eslint/no-input-rename
  @Input('items')
  public set itemsValue(items: UrlListItem[]) {
    this.items = items;
  }

  @Input()
  public isBold = false;

  public items: UrlListItem[] = [];
}
